export default "__VITE_ASSET__cytMh2Ms__"